import { Component, Input, EventEmitter, Output } from '@angular/core';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { ActivatedRoute } from '@angular/router';
import { EntityPagedRequestParameters, EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { SolicitacaoCancelamentoGarantia } from 'src/app/model/solicitacao-cancelamento-garantia.model';
import { CommonModule } from '@angular/common';  
import { BrowserModule } from '@angular/platform-browser';

@Component({
    selector: 'app-cancelamento-listagem',
    templateUrl: './cancelamento-listagem.component.html',
    styleUrls: ['./cancelamento-listagem.component.scss'],
    standalone: false
})
export class CancelamentoListagemComponent {

  private agentesFinanceiros: AgenteFinanceiro[] = [];

  @Input() public solicitacoesCancelamento: SolicitacaoCancelamentoGarantia[];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Input() public ehAgenteFinanceiro: boolean;
  
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();

  @Input() public mostrarExportarSolicitacoesCancelamento: boolean;
  @Output() public aoExportarSolicitacoesCancelamento: EventEmitter<any> = new EventEmitter<any>();

  
  constructor( private activatedRoute: ActivatedRoute) {
    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; // resolver
  }

  public opcoesPaginacao: number[];
  public atributosOrdenacao: EntityOrderedRequestParameters;

  ngOnInit(): void {
    if (this.mostrarExportarSolicitacoesCancelamento == undefined) {
      this.mostrarExportarSolicitacoesCancelamento = true;
    }
    this.opcoesPaginacao = [10, 15, 20];
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.solicitacoesCancelamento = this.solicitacoesCancelamento.sort((a, b) => {
      if (ord.sentido === 'asc') {
        return this.compara(a, b, ord.atributo);
      } else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) === this.fetchFromObject(b, atributo)) {
      return 0;
    } else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      } else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if (typeof obj === 'undefined') {
      return false;
    }

    const _index = prop.indexOf('.');
    if (_index > -1) {
        return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  public nomeAgente(cnpj: string) {
    const agentes = this.agentesFinanceiros.filter(item => item.cnpj === cnpj);
    return agentes.length > 0 ? agentes[0].nome : `agente cnpj ${cnpj} desconhecido.`;
  }

  public exportarSolicitacoesCancelamento(): void {
    this.aoExportarSolicitacoesCancelamento.emit();
  }
}
